import type { LegacyUser } from '../../../../../app/ApiGen';
import { OrganisationId } from '../../../../../config';
import { DateFormatDateFns, TimeFormatDateFns } from '../../../../../utils/dateFormat';
import { emailDomain } from '../../../../../utils/format';

export const shouldTrackAnalytics = (user?: LegacyUser): boolean => {
  if (!user) {
    return false;
  }
  const { email, organisations } = user;
  const isEvnexUser = emailDomain(email) === 'evnex.com';
  const isInEvnexCpo = organisations.some((org) => org.id === OrganisationId.EvnexCpo);
  return !isEvnexUser && !isInEvnexCpo;
};

export const csvDateFormat = `${DateFormatDateFns.Filename} ${TimeFormatDateFns.TwentyFourHoursWithSeconds}`;
